import styled from 'styled-components'

export const CustomPathologyContainer = styled.div`
  margin-top: 2rem;

  div:not(:last-of-type) {
    margin-bottom: 2.5rem;
  }

  h4 {
    font-weight: 500;
    font-size: 20px;
    color: var(--grey2);
    margin-bottom: 1rem;
  }

  ul {
    font-size: 16px;
    line-height: 22px;
    color: var(--grey2);
    list-style-position: inside;
  }

  @media (min-width: 650px) {
    ul {
      column-count: 2;
      column-gap: 2rem;
    }
  }
`
